/**
 * Client-side email format check for registration (L01 FR5).
 *
 * Deliberately a SIMPLE, dependency-free regex: it is a pre-flight guard so an
 * obviously malformed address is caught before the round trip, NOT the source
 * of truth. The backend's Pydantic `EmailStr` (email-validator) is authoritative
 * and HARD-rejects anything this misses. We intentionally do not pull in an npm
 * validation package for a single field.
 *
 * The pattern requires: at least one non-space/non-@ char, a single "@", a
 * domain with at least one dot, and a non-empty TLD — no leading/trailing spaces.
 */
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** True when `value` looks like a plausible email address. */
export function isValidEmail(value) {
  if (typeof value !== "string") return false;
  return EMAIL_RE.test(value.trim());
}
